// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.table-container {
  display: flex; /* Ensures flexbox behavior */
  flex-direction: column; /* Align items vertically */
  align-items: center; /* Center content horizontally */
  margin: auto;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3) , -0 -6px 8px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  margin-top: 10px;
}

/* Title */
.table-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

/* Table */
.responsive-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
}

.responsive-table thead {
  background-color: #172639;
  color: #fff;
  cursor: pointer;
}

.responsive-table th,
.responsive-table td {
  padding: 12px 15px; /* Add padding for better readability */
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.responsive-table tbody tr:hover {
  background-color: rgb(225, 225, 225);
  cursor: pointer;
}

/* Pagination styles */
.pagination {
  display: flex;
  justify-content: center; 
  font-size: 10px!important;
}


/* Responsive Styles */
@media (max-width: 768px) {
  .table-container {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ReusableTable.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa,EAAE,6BAA6B;EAC5C,sBAAsB,EAAE,2BAA2B;EACnD,mBAAmB,EAAE,gCAAgC;EACrD,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB,EAAE,uCAAuC;EAC3D,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;;AAGA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* Container */\n.table-container {\n  display: flex; /* Ensures flexbox behavior */\n  flex-direction: column; /* Align items vertically */\n  align-items: center; /* Center content horizontally */\n  margin: auto;\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3) , -0 -6px 8px rgba(0, 0, 0, 0.1);\n  font-size: 13px;\n  margin-top: 10px;\n}\n\n/* Title */\n.table-title {\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n/* Table Wrapper */\n.table-wrapper {\n  overflow-x: auto;\n  width: 100%;\n}\n\n/* Table */\n.responsive-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n}\n\n.responsive-table thead {\n  background-color: #172639;\n  color: #fff;\n  cursor: pointer;\n}\n\n.responsive-table th,\n.responsive-table td {\n  padding: 12px 15px; /* Add padding for better readability */\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.responsive-table tbody tr:hover {\n  background-color: rgb(225, 225, 225);\n  cursor: pointer;\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n  justify-content: center; \n  font-size: 10px!important;\n}\n\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .table-container {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
